import { AppButton } from "../../../../../../../shared/components/AppButton";
import { AppLabel } from "../../../../../../../shared/components/AppLabel";
import { AppNewInput } from "../../../../../../../shared/components/AppNewInput";
import { TCreateCaseCommentBlock } from "../../../../../types";
import styles from "./styles.module.css";

interface Props {
  createCaseBlock: TCreateCaseCommentBlock;
  handleChangeCommentField: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    id: string,
    field: keyof Omit<TCreateCaseCommentBlock, "id">,
  ) => void;
  handleDeleteCommentBlock: (id: string) => void;
  handleSaveComment: (id: string) => void;
}

export const CreateCaseCommentBlock = (props: Props) => {
  return (
    <div className={styles["create-comment-container"]}>
      <div className={styles["create-comment-field-container"]}>
        <AppLabel className={styles["label"]}>Автор</AppLabel>
        <AppNewInput
          value={props.createCaseBlock.author}
          onChange={(e) =>
            props.handleChangeCommentField(
              e,
              props.createCaseBlock.id,
              "author",
            )
          }
        />
      </div>
      <div className={styles["create-comment-field-container"]}>
        <AppLabel className={styles["label"]}>Комментарий</AppLabel>
        <AppNewInput
          value={props.createCaseBlock.comment}
          onChange={(e) =>
            props.handleChangeCommentField(
              e,
              props.createCaseBlock.id,
              "comment",
            )
          }
          minRows={3}
          multiline
        />
      </div>
      <div className={styles["comment-actions"]}>
        <AppButton
          buttonType={"outlined"}
          onClick={() =>
            props.handleDeleteCommentBlock(props.createCaseBlock.id)
          }
        >
          Удалить
        </AppButton>
        <AppButton
          buttonType={"contained"}
          onClick={() => props.handleSaveComment(props.createCaseBlock.id)}
          disabled={
            !Boolean(
              props.createCaseBlock.author && props.createCaseBlock.comment,
            )
          }
        >
          Сохранить
        </AppButton>
      </div>
    </div>
  );
};
